module.exports = __webpack_public_path__ + "img/employees-bg.bab39cb0.webp";